import fastdom from "fastdom"

const getRect = (el) => (el ? el.getBoundingClientRect() : null)

/**
 * Reads geometry boundaries of the elements
 * @param {HTMLElement} els - Any elements in DOM
 * @param {function} next - A callback function to provide array of data after the function is finished.
 * @returns {void}
 */
function readBoundaries(els, next) {
  fastdom.measure(() => next(els.map(getRect)))
}

export default readBoundaries
